import uuid from 'uuid/v4'
import { isCreativeClassificationActive, updateIntegrationsState } from './utils'
import { colors } from '../../../global/constants'

// check the setTemplate details to trigger an error to prevent save

const initialState = {
  templateFields: [],
  fieldsById: {},
  templateFieldsById: {},
  template: {},
  parameters: [],
  validations: [],
  validationsById: {},
  integrations: [],
  integrationsById: {},
  fieldsets: [],
  fieldsetsById: {},
  hasUserChangedData: false,
  colorItemsByType: {
    patterns: {},
    fieldsets: {},
  },
  currentIssue: null,
  issues: { errors: [], warnings: [] },
  integrationNotifications: {},
  colors: [
    { backgroundColor: colors.blue.smokey, color: 'white' },
    { backgroundColor: colors.teal.main, color: 'black' },
    { backgroundColor: colors.pink.dark, color: 'white' },
    { backgroundColor: colors.green.lime, color: 'black' },
    { backgroundColor: colors.blue.dark, color: 'white' },
    { backgroundColor: colors.teal.light, color: 'black' },
    { backgroundColor: colors.yellow.light, color: 'black' },
    { backgroundColor: colors.pink.main, color: 'white' },
    { backgroundColor: colors.purple.dark, color: 'white' },
    { backgroundColor: colors.orange.main, color: 'black' },
    { backgroundColor: colors.blue.smokey, color: 'white' },
    { backgroundColor: colors.gray.main, color: 'black' },
    { backgroundColor: colors.green.main, color: 'white' },
    { backgroundColor: colors.gray.dark, color: 'white' },
    { backgroundColor: colors.green.blue, color: 'black' },
    { backgroundColor: colors.green.yellow, color: 'black' },
    { backgroundColor: colors.blue.smokey, color: 'white' },
    { backgroundColor: colors.teal.main, color: 'black' },
    { backgroundColor: colors.pink.dark, color: 'white' },
    { backgroundColor: colors.green.lime, color: 'black' },
    { backgroundColor: colors.blue.dark, color: 'white' },
    { backgroundColor: colors.teal.light, color: 'black' },
    { backgroundColor: colors.yellow.light, color: 'black' },
    { backgroundColor: colors.pink.main, color: 'white' },
    { backgroundColor: colors.purple.dark, color: 'white' },
    { backgroundColor: colors.orange.main, color: 'black' },
    { backgroundColor: colors.blue.smokey, color: 'white' },
    { backgroundColor: colors.gray.main, color: 'black' },
    { backgroundColor: colors.green.main, color: 'white' },
    { backgroundColor: colors.gray.dark, color: 'white' },
    { backgroundColor: colors.green.blue, color: 'black' },
    { backgroundColor: colors.green.yellow, color: 'black' },
  ],
  loading: true,
  savingTemplate: false,
  readyToValidate: false,
}

export function Template(state = initialState, action) {
  switch (action.type) {
    case 'SET_SAVING_TEMPLATE':
      return {
        ...state,
        savingTemplate: action.payload,
      }
    case 'RESET_TEMPLATE_CHANGED_STATE':
      return {
        ...state,
        hasUserChangedData: false,
      }
    case 'SET_TEMPLATE_DETAILS':
      return {
        ...state,
        template: { ...state.template, ...action.payload },
        hasUserChangedData: true,
      }
    case 'SET_FIELDS':
      return {
        ...state,
        templateFields: action.payload,
        hasUserChangedData: true,
      }
    case 'GET_TEMPLATE':
      return {
        ...state,
      }
    case 'SET_TEMPLATE': {
      const colorItemsByType = JSON.parse(JSON.stringify(state.colorItemsByType))
      const colorsState = initialState.colors.slice()

      // gross -- transform domain restrictions

      const mutateField = (action.payload.template_fields || action.payload.templateFields).find(
        tf => tf.governance_type === 'link',
      )
      if (mutateField) {
        mutateField.field.link_governance.domain_restrictions =
          mutateField.field.link_governance.domain_restrictions.map(dr => dr.domain)
      }

      const tfs = (action.payload.template_fields || action.payload.templateFields).sort((a, b) => {
        return a.precedence - b.precedence
      })
      const tfsById = tfs.reduce((memo, item) => {
        if (item.governance_type === 'pattern') {
          colorItemsByType.patterns[item.field_id] = colorsState.splice(0, 1)[0]
        }
        memo[item.id] = item
        return memo
      }, {})
      const fieldsById = Object.values(tfsById).reduce((memo, item) => {
        if (item.field) {
          memo[item.field.id] = { ...item.field, template_field_id: item.id }
        }
        return memo
      }, {})

      // TODO: we need to be able to handle the differenting metadata stuff here better. not all of them bcc, but don't want to work with JSON elsewhere. Likely need a util that sets up the meatadat correctly for each type of integration.
      const integrationsById = updateIntegrations(
        fieldsById,
        action.payload.integrations.reduce((memo, item) => {
          memo[item.id] = {
            ...item,
            file_type: item.file_type ? JSON.parse(item.file_type) : [],
            metadata: {
              ...item.metadata,
            },
            included_output_fields: item.included_output_fields
              ? JSON.parse(item.included_output_fields)
              : [],
          }
          return memo
        }, {}),
        tfsById,
      )

      const fsById = action.payload.fieldsets.reduce((memo, item) => {
        memo[item.id] = item
        colorItemsByType.fieldsets[item.id] = colorsState.splice(0, 1)[0]
        return memo
      }, {})

      return {
        ...state,
        templateFields: tfs.map(tf => tf.id),
        template: {
          ...action.payload,
          isCreativeClassificationEnabled: isCreativeClassificationActive(action.payload),
        },
        fields: (action.payload.template_fields || action.payload.templateFields).map(
          tf => tf.field,
        ),
        fieldsById,
        templateFieldsById: tfsById,
        integrationsById,
        integrations: Object.values(integrationsById),
        validations: action.payload.link_validations,
        fieldsets: action.payload.fieldsets,
        parameters: action.payload.parameters
          .sort((a, b) => {
            return a.precedence - b.precedence
          })
          .map(p => {
            return {
              ...p,
              field_id: tfsById[p.template_field_id]?.field_id,
              template_field_id: null,
              id: `TEMP_${uuid()}`,
              template_field: null,
            }
          }),
        fieldsetsById: fsById,
        colors: colorsState,
        colorItemsByType,
        loading: false,
      }
    }
    case 'ADD_LINK_FIELD': {
      const linkField = {
        name: 'Link',
        governance_type: 'link',
        link_governance: {
          domain_restrictions: [],
        },
        id: `TEMP_${uuid()}`,
      }
      const linkTF = {
        id: `TEMP_${uuid()}`,
        field_id: linkField.id,
        field: linkField,
        name: 'Link',
        governance_type: 'link',
        link_governance: {},
        visible_on_form: true,
        precedence: state.templateFields.length + 1,
      }
      const addLFTemplateFields = [...state.templateFields, linkTF.id]
      const newFieldsById = { ...state.fieldsById, [linkField.id]: linkField }
      const addLFTemplateFieldsById = { ...state.templateFieldsById, [linkTF.id]: linkTF }
      return {
        ...state,
        templateFields: addLFTemplateFields,
        templateFieldsById: addLFTemplateFieldsById,
        fieldsById: newFieldsById,
        hasUserChangedData: true,
      }
    }
    case 'TOGGLE_CREATIVE_CLASSIFICATION': {
      const isCreativeClassificationEnabled = action.payload

      const newState = {
        ...state,
        hasUserChangedData: true,
        template: {
          ...state.template,
          isCreativeClassificationEnabled,
        },
      }

      return newState
    }
    case 'ADD_FIELD_SETS': {
      const fieldsets = action.payload
      // go through fieldsets and add them to the template.
      const addFSColors = state.colors.slice()
      const addFSColorsByType = JSON.parse(JSON.stringify(state.colorItemsByType))
      const addFSFieldsetsById = JSON.parse(JSON.stringify(state.fieldsetsById))

      fieldsets.forEach(fs => {
        if (!addFSColorsByType.fieldsets[fs.id]) {
          addFSColorsByType.fieldsets[fs.id] = addFSColors.splice(0, 1)[0]
        }
        if (!addFSFieldsetsById[fs.id]) {
          addFSFieldsetsById[fs.id] = fs
        }
      })

      return {
        ...state,
        colors: addFSColors,
        colorItemsByType: addFSColorsByType,
        fieldsetsById: addFSFieldsetsById,
        hasUserChangedData: true,
      }
    }
    case 'ADD_FIELDS': {
      const addColors = state.colors.slice()
      const addColorItemsByType = JSON.parse(JSON.stringify(state.colorItemsByType))
      const addFieldsetsById = JSON.parse(JSON.stringify(state.fieldsetsById))
      const addTemplateFieldsById = JSON.parse(JSON.stringify(state.templateFieldsById))
      const addTemplateFields = JSON.parse(JSON.stringify(state.templateFields))

      action.payload.forEach((field, index) => {
        if (!field) return // A fieldset can be added and it not include fields yet.

        if (field.fieldset_id && !state.fieldsetsById[field.fieldset_id]) {
          addFieldsetsById[field.fieldset_id] = { id: field.fieldset_id }
        }

        // TODO: make a function that converts segments to fields.
        const newTf = {
          id: `TEMP_${uuid()}`,
          field_id: field.id,
          field,
          precedence: state.templateFields.length + index,
          governance_type: field.is_pattern ? 'pattern' : null,
          is_pattern: field.is_pattern,
          visible_on_form: true,
        }

        // if it doesn't have a field_id, it's a field.
        if (!field.field_id) {
          addColorItemsByType.patterns[newTf.field_id] = addColors.splice(0, 1)[0]

          addTemplateFieldsById[newTf.id] = newTf
          addTemplateFields.push(newTf.id)
        } else {
          // don't know when this would happen?
          addTemplateFieldsById[newTf.id] = newTf
          field.precedence = state.templateFields.length + index
          return field
        }
      })
      // const newFields = state.templateFields.concat()

      const addFieldsById = Object.values(addTemplateFieldsById).reduce((memo, item) => {
        memo[item.field_id] = { ...item.field, template_field_id: item.id }
        return memo
      }, {})

      const addIntegrations = updateIntegrations(
        addFieldsById,
        state.integrationsById,
        addTemplateFieldsById,
      )

      return {
        ...state,
        templateFields: addTemplateFields,
        templateFieldsById: addTemplateFieldsById,
        integrationsById: addIntegrations,
        integrations: Object.values(addIntegrations),
        fieldsById: addFieldsById,
        fieldsetsById: addFieldsetsById,
        fieldsets: Object.values(addFieldsetsById),
        colors: addColors,
        colorItemsByType: addColorItemsByType,
        hasUserChangedData: true,
      }
    }
    case 'UPDATE_TEMPLATE_FIELD': {
      const fieldsWithResetCreativeClassification = { ...state.templateFieldsById }
      const newCreativeClassification = action.payload.classification_parameter_type

      // if isCreativeClassificationEnabled is set to true,
      // we need to ensure that only 1 field is marked as SOURCE_URL and TITLE, so we reset
      // all other fields to null, and then we add the new one. we also need to check if
      // the field being updated is the same as the one we are setting
      // otherwise, we don't make any operations
      if (state.template.isCreativeClassificationEnabled) {
        Object.keys(state.templateFieldsById).forEach(key => {
          const field = fieldsWithResetCreativeClassification[key]
          if (field.classification_parameter_type === newCreativeClassification) {
            fieldsWithResetCreativeClassification[key] = {
              ...field,
              classification_parameter_type: null,
            }
          }
        })
      }

      const newTemplateFieldsById = {
        ...fieldsWithResetCreativeClassification,
        [action.payload.id]: action.payload,
      }

      const updatedFieldsById = Object.values(newTemplateFieldsById).reduce((memo, tf) => {
        memo[tf.field_id] = { ...tf.field, template_field_id: tf.id }
        return memo
      }, {})

      const updatedFieldIntegrations = updateIntegrations(
        updatedFieldsById,
        state.integrationsById,
        newTemplateFieldsById,
      )

      /**
       * This piece of code addresses the issue where a user has a pattern that is autofilling
       * from the cv_id field. When creating the fields, the backend doesn't know where to pull the autofill
       * from (in case of template fields), so we need to pass in the governance so the backend can query
       * the field.
       *
       * This should only be used for cv_id.
       */
      const { field, autofill } = action.payload
      if (field?.segment_type === 'variable' && autofill !== null) {
        const originFieldId = autofill.field_id
        const originFieldGovernanceType = state.fieldsById[originFieldId]?.governance_type

        action.payload.autofill = {
          ...autofill,
          origin_field_governance_type: originFieldGovernanceType,
        }
      }

      // if the template isCreativeClassificationEnabled, we need to update the template_fields
      // with the new values, because we need to know what the classification_parameter_type is.
      // Otherwise, we just return the current template_fields
      const updatedTemplateFields =
        state.template.isCreativeClassificationEnabled && state.template.template_fields
          ? state.template.template_fields.map(tf => {
              if (newTemplateFieldsById[tf.id]) {
                return {
                  ...tf,
                  ...newTemplateFieldsById[tf.id],
                }
              }

              return tf
            })
          : state.template.template_fields

      return {
        ...state,
        templateFieldsById: newTemplateFieldsById,
        fieldsById: updatedFieldsById,
        integrationsById: updatedFieldIntegrations,
        inteegrations: Object.values(updatedFieldIntegrations),
        hasUserChangedData: true,
        template: {
          ...state.template,
          template_fields: updatedTemplateFields,
        },
      }
    }
    case 'REMOVE_TEMPLATE_FIELD': {
      // should this happen here?
      // check of the field being removed and wiping out any of it's children should it be a pattern.
      const fieldsToRemove = [action.payload.id]
      if (action.payload?.field?.is_pattern || action.payload.governance_type === 'pattern') {
        Object.values(state.templateFieldsById).forEach(tf => {
          if (tf.field?.segment_parent_field_id == action.payload.field_id) {
            fieldsToRemove.push(tf.id)
          }
        })
      }

      const newTemplateFields = state.templateFields.filter(tf => !fieldsToRemove.includes(tf))
      const newTemplateFieldsById = fieldsToRemove.reduce((tf, key) => {
        const { [key]: _deleted, ...rest } = tf
        return rest
      }, state.templateFieldsById)

      const removeFieldsById = Object.values(newTemplateFieldsById).reduce((memo, item) => {
        if (item.field) {
          memo[item.field.id] = { ...item.field, template_field_id: item.id }
        }
        return memo
      }, {})

      const removeIntegrations = updateIntegrations(
        removeFieldsById,
        state.integrationsById,
        newTemplateFieldsById,
      )

      // if a parameter is mapped to this template_field, we need to remove that link
      // if that parameter has associated fieldsets, we need to also remove those.
      // BUT we may still want to keep the parameter. Because it might have a name or is being used delibeartly in the link field
      const upParams = [...state.parameters]
      const tf_field_id = action.payload.field_id
      const paramIndex = upParams.findIndex(p => p.field_id == tf_field_id)
      if (paramIndex > -1) {
        upParams.splice(paramIndex, 1, {
          ...upParams[paramIndex],
          template_field_id: null,
          field_id: null,
          id: `TEMP_${uuid()}`,
          fieldset_ids: [],
        })
      }

      return {
        ...state,
        templateFields: newTemplateFields,
        fieldsById: removeFieldsById,
        templateFieldsById: newTemplateFieldsById,
        integrationsById: removeIntegrations,
        integrations: Object.values(removeIntegrations),
        parameters: upParams,
        hasUserChangedData: true,
      }
    }

    case 'ADD_PARAMETER': {
      const newParameters = [
        ...state.parameters,
        {
          field_id: null,
          fieldset_ids: [],
          id: `TEMP_${uuid()}`,
          name: '',
          precedence: state.parameters.length + 1,
          template_field: null,
          template_field_id: null,
          template_id: state.template.id,
          transform: 'none',
          url_encoding: 'dynamic',
        },
      ]
      return {
        ...state,
        parameters: newParameters,
        hasUserChangedData: true,
      }
    }
    case 'REMOVE_PARAMETER': {
      const remainingParameters = state.parameters.slice()
      remainingParameters.splice(
        state.parameters.findIndex(param => param.id === action.payload.id),
        1,
      )
      return {
        ...state,
        parameters: remainingParameters,
        hasUserChangedData: true,
      }
    }
    case 'SET_PARAMETERS': {
      return {
        ...state,
        parameters: action.payload,
        hasUserChangedData: true,
      }
    }

    case 'SET_PARAMETER': {
      const updatedParameters = state.parameters.slice()
      const templateFieldId = action.payload.field_id
        ? Object.values(state.templateFieldsById).find(tf => tf.field_id == action.payload.field_id)
            ?.id
        : null
      const upp = { ...action.payload, template_field_id: templateFieldId }
      const paramIndex = updatedParameters.findIndex(p => p.id == action.payload.id)
      updatedParameters.splice(paramIndex > -1 ? paramIndex : updatedParameters.length, 1, upp)
      return {
        ...state,
        parameters: updatedParameters,
        hasUserChangedData: true,
      }
    }
    case 'SET_INTEGRATIONS_LOADED':
      return updateIntegrationsState({
        state,
        integrations: action.payload,
        triggerUserChangedData: false,
      })

    case 'SET_INTEGRATIONS':
      return updateIntegrationsState({
        state,
        integrations: action.payload,
        triggerUserChangedData: true,
      })

    case 'UPDATE_INTEGRATION_NOTIFICATION':
      return {
        ...state,
        hasUserChangedData: true,
        integrationNotifications: {
          ...state.integrationNotifications,
          [action.payload.integrationId]: action.payload.notification,
        },
      }

    case 'UPDATE_VALIDATION': {
      const updatedValidations = state.validations.slice()
      if (updatedValidations.map(val => val.uuid).includes(action.payload.uuid)) {
        updatedValidations.splice(
          updatedValidations.findIndex(v => v.uuid === action.payload.uuid),
          1,
          action.payload,
        )
      } else {
        updatedValidations.push(
          action.payload.uuid
            ? action.payload
            : { uuid: uuid(), ...action.payload, newValidation: true },
        )
      }
      return {
        ...state,
        hasUserChangedData: true,
        validations: updatedValidations,
      }
    }
    case 'ADD_VALIDATION': {
      const payloadOptions = (
        Array.isArray(action.payload.options)
          ? [...action.payload.options]
          : Object.values(action.payload.options)
      ).reduce(
        (memo, opt) => ({
          ...memo,
          [opt.slug]: { ...opt, metadata: {} },
        }),
        {},
      )
      return {
        ...state,
        hasUserChangedData: true,
        validations: [
          ...state.validations,
          { ...action.payload, options: payloadOptions, uuid: uuid(), newValidation: true },
        ],
      }
    }
    case 'RESET_VALIDATIONS':
      return {
        ...state,
        validations: action.payload,
      }

    case 'REMOVE_VALIDATION':
      return {
        ...state,
        validations: state.validations.filter(val => val.uuid !== action.payload.uuid),
      }

    case 'RESET_TEMPLATE_STORE':
      return {
        ...initialState,
      }

    case 'INIT_TEMPLATE': {
      const newId = uuid()
      const tfId = uuid()
      const initTemplateFields = [
        {
          governance_type: 'cv_id',
          id: `TEMP_${tfId}`,
          uuid: tfId,
          field_id: newId,
          field: { name: 'Claravine ID', governance_type: 'cv_id', id: newId },
          visible_on_form: false,
          is_pattern: false,
        },
      ]
      const initTemplateFieldsById = initTemplateFields.reduce((memo, item) => {
        memo[item.id] = item
        return memo
      }, {})
      const initFieldsById = Object.values(initTemplateFieldsById).reduce((memo, item) => {
        if (item.field) {
          memo[item.field.id] = { ...item.field, template_field_id: item.id }
        }
        return memo
      }, {})

      const integrationId = `TEMP_${uuid()}`

      const initIntegrationsById = {
        [integrationId]: {
          name: '',
          assigned_entity_type: 'template',
          id: integrationId,
          integration_id: action.payload.emailIntegrationId,
          slug: 'email-output',
          integration_type: 'OUTPUT',
          type: 'OUTPUT',
          filename_pattern: '{{submitted_at}}_{{template_name}}',
          folder: null,
          report_type: 'default',
          include_summary_header: true,
          included_output_fields: [],
          file_type: ['csv', 'xlsx', 'json'],
          url: 'https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/email-output.png',
          assigned_integration_id: integrationId,
          connector_id: null,
          connector_type_id: -1,
          metadata: {},
          config_hash: null,
        },
      }

      return {
        ...state,
        template: { uuid: uuid() },
        templateFields: initTemplateFields.map(itf => itf.id),
        templateFieldsById: initTemplateFieldsById,
        fieldsById: initFieldsById,
        integrationsById: initIntegrationsById,
        integrations: Object.values(initIntegrationsById),
        loading: false,
      }
    }
    case 'SET_DOMAINS': {
      const domainTemplateFields = Object.values(state.templateFieldsById)
      const linkFieldIndex = domainTemplateFields.findIndex(
        tf => tf.governance_type === 'link' || tf.field.governance_type === 'link',
      )
      const newLinkField = {
        ...domainTemplateFields[linkFieldIndex],
        field: {
          ...domainTemplateFields[linkFieldIndex].field,
          link_governance: {
            ...domainTemplateFields[linkFieldIndex].field.link_governance,
            domain_restrictions: action.payload,
          },
        },
      }
      const updateDomainTemplateFields = {
        ...state.templateFieldsById,
        [newLinkField.id]: newLinkField,
      }
      const updateDomainFields = {
        ...state.fieldsById,
        [newLinkField.field.id]: { ...newLinkField.field },
      }

      return {
        ...state,
        templateFieldsById: updateDomainTemplateFields,
        hasUserChangedData: true,
        fieldsById: updateDomainFields,
      }
    }
    case 'READY_TO_VALIDATE':
      return {
        ...state,
        readyToValidate: true,
      }

    case 'REFRESH_PATTERN': {
      // get the tf from the action.payload. Grab the field_id.
      const patternFieldId = action.payload.tf.field_id
      // go find all the fields we have, that have that segement_parent_field_id and gather them up.
      const currentPatternFields = Object.values(state.templateFieldsById).reduce((memo, item) => {
        if (item.field?.segment_parent_field_id === patternFieldId) {
          memo.push(item.field_id)
        }
        return memo
      }, [])

      const refreshPatternTemplateFieldsById = JSON.parse(JSON.stringify(state.templateFieldsById))
      const refreshPatternTemplateFields = state.templateFields.slice()
      const refreshPatternFieldsById = JSON.parse(JSON.stringify(state.fieldsById))
      // then go trhough the passed in Pattern. and find fields that need to be added, and need to be removed.
      const fullPatternFields = action.payload.pattern.segments

      fullPatternFields.forEach((fpf, index) => {
        const currentPatternFieldIndex = currentPatternFields.findIndex(cpf => cpf === fpf.id)
        if (currentPatternFieldIndex > -1) {
          currentPatternFields.splice(currentPatternFieldIndex, 1)
        } else {
          // we need to add it
          const newRefreshTF = {
            id: `TEMP_${uuid()}`,
            field_id: fpf.id,
            field: fpf,
            precedence: state.templateFields.length + index,
            governance_type: null,
            is_pattern: false,
            visible_on_form: false,
          }
          refreshPatternTemplateFieldsById[newRefreshTF.id] = newRefreshTF
          refreshPatternTemplateFields.push(newRefreshTF.id)
          refreshPatternFieldsById[fpf.id] = { ...fpf, template_field_id: newRefreshTF.id }
        }
      })

      return {
        ...state,
        templateFieldsById: refreshPatternTemplateFieldsById,
        templateFields: refreshPatternTemplateFields,
        fieldsById: refreshPatternFieldsById,
      }
    }
    case 'SET_CREATIVE_CONFIGURATION':
      return {
        ...state,
        hasUserChangedData: true,
        template: {
          ...state.template,
          creativeConfiguration: action.payload,
        },
      }

    case 'SET_CREATIVE_THRESHOLD': {
      const { id, value } = action.payload

      const updatedCreativeConfiguration = state.template.creativeConfiguration.map(
        classification => {
          if (classification.categoryId === id) {
            return { ...classification, threshold: value }
          }

          return classification
        },
      )

      return {
        ...state,
        hasUserChangedData: true,
        template: {
          ...state.template,
          creativeConfiguration: updatedCreativeConfiguration,
        },
      }
    }

    default:
      return state
  }
}

export function updateIntegrations(updatedFieldsById, integrationsState, templateFieldsById) {
  const fieldIds = Object.keys(updatedFieldsById)
  const integrations = JSON.parse(JSON.stringify(integrationsState))

  // loop through every integration
  Object.values(integrations).forEach(integration => {
    // seems like a good key to pick
    if (integration.integration_id == 13) {
      integration.metadata.bcc =
        typeof integration.metadata.bcc === 'string'
          ? JSON.parse(integration.metadata.bcc)
          : integration.metadata.bcc
      integration.metadata.to =
        typeof integration.metadata.to === 'string'
          ? JSON.parse(integration.metadata.to)
          : integration.metadata.to
      integration.metadata.cc =
        typeof integration.metadata.cc === 'string'
          ? JSON.parse(integration.metadata.cc)
          : integration.metadata.cc
    }
    if (integration.report_type === 'perTarget') {
      integration.included_output_fields = [
        {
          id: 'Target Fields',
          name: 'Target Fields',
          hidden: false,
          isMeta: false,
          display: 'Target Fields',
          selected: true,
        },
      ]
    } else {
      const isDefault = integration.report_type === 'default'

      const retainFields = []
      const initialItemsById =
        integration.included_output_fields?.reduce((memo, item) => {
          // update name and display if needed
          const newItem = {
            ...item,
            name: updatedFieldsById[item.id]?.name || item.name,
          }
          // if it's not in template fields it don't exist anymore, don't include it.
          if (fieldIds.includes(`${item.id}`) || item.isMeta) {
            memo[item.id] = newItem
            if (!isNaN(item.id)) {
              // Remove the replace_with prop if the config has been updated with a real ID
              if (item.replace_with_governance_type) delete item.replace_with_governance_type
            }
            retainFields.push(newItem)
          }
          return memo
        }, {}) || []

      // find the items that aren't included in the output configuration and add those to the end of the item list.
      const addItems = Object.values(updatedFieldsById).reduce((memo, item) => {
        if (!initialItemsById[item.id]) {
          const toPush = {
            id: item.id,
            name: item.name,
            isMeta: false,
            fieldType: 'template_field',
            display: item.name,
            isHidden:
              !templateFieldsById[updatedFieldsById[item.id]?.template_field_id]?.visible_on_form,
            selected:
              !!templateFieldsById[updatedFieldsById[item.id]?.template_field_id]?.visible_on_form,
          }
          // If the ID is a temporary one (typical of new CVID and link fields),
          // add a replace_with_governance_type property so the backend can get the real ID
          if (
            (item.governance_type === 'link' || item.governance_type === 'cv_id') &&
            isNaN(item.id)
          ) {
            toPush.replace_with_governance_type = item.governance_type
          }
          memo.push(toPush)
        }
        return memo
      }, [])

      let updatedFields = [...retainFields, ...addItems]

      const isFieldSelected = (fieldId, isMeta) => {
        const selected = updatedFields.find(({ id }) => id === fieldId)?.selected
        if (selected) return selected

        return isMeta
          ? false
          : templateFieldsById[updatedFieldsById[fieldId]?.template_field_id]?.visible_on_form
      }

      if (isDefault) {
        updatedFields = updatedFields
          .sort((a, b) => {
            return (
              templateFieldsById[updatedFieldsById[a.id]?.template_field_id]?.precedence -
              templateFieldsById[updatedFieldsById[b.id]?.template_field_id]?.precedence
            )
          })
          .sort((a, b) => {
            return a.isMeta - b.isMeta
          })
          .map(f => ({
            ...f,
            display: f.name,
            isHidden: f.isMeta
              ? true
              : !templateFieldsById[updatedFieldsById[f.id]?.template_field_id]?.visible_on_form,
            selected: isFieldSelected(f.id, f.isMeta),
          }))
      }

      integration.included_output_fields = updatedFields
    }
  })

  // TODO: handle per_target
  // give up cause no one knows what that even means.
  return integrations
}
